import axios from "axios";

const API_GO = process.env.REACT_APP_API_GO;

export const getIntegrationUsage = async (params) => {
	const { data } = await axios.get(`${API_GO}/app/history/integration/usage`, { params });
	return data;
};

export const syncIntegrationUsages = async (payload) => {
	const { data } = await axios.post(`${API_GO}/app/history/integration/sync`, payload);
	return data;
};

export const deleteIntegrationCode = async (payload) => {
	const { data } = await axios.post(`${API_GO}/app/history/integration/delete-code`, payload);
	return data;
};
